import styled from 'styled-components'
import { InputElement, IconContainer } from 'ui/components/forms/Input/styled'

export const FormStyled = styled.form`
  padding-top: 16px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  & label:not(:last-child) {
    margin-bottom: 0;
  }

  ${InputElement} {
    padding-left: 16px;
    padding-right: 40px;
  }

  ${IconContainer} {
    margin-top: -5px;
    color: var(--t-td-button-icon-color);
  }
`

export const FormButtons = styled.div`
  display: flex;
  gap: 8px;
`
